import { Box } from "@repo/components/src/ui/box";
import { Button, ButtonText } from "@repo/components/src/ui/button";
import { HStack } from "@repo/components/src/ui/hstack";
import { Text } from "@repo/components/src/ui/text";
import { Link } from "expo-router";

type Props = { brandId: string };

/**
 * Stands where the composer would be on a retired (old interview-style) chat.
 *
 * Those chats open read-only; the way forward is a new campaign chat, which `?new=1`
 * opens even when others exist.
 */
const LegacyChatNotice = ({ brandId }: Props) => (
  <Box className="border-t border-outline-100 bg-background-50 px-4 py-3">
    <HStack space="sm" className="flex-wrap items-center justify-between">
      <Text className="flex-1 text-sm text-typography-600">
        Esta conversación usa una versión anterior del asistente. Crea una
        campaña nueva para continuar.
      </Text>
      <Link
        href={{
          pathname: "/app/(brands)/[brandId]/(main)/campaign/ai",
          params: { brandId, new: "1" },
        }}
        asChild
      >
        <Button action="brand" variant="solid" size="sm" rounded="lg">
          <ButtonText>Crear campaña nueva</ButtonText>
        </Button>
      </Link>
    </HStack>
  </Box>
);

export default LegacyChatNotice;
